import React from "react";
import { Autocomplete, Box, CircularProgress, FormControlLabel, Radio, RadioGroup, TableCell, TableRow, TextField, Typography } from "@mui/material";

/**
 * YouTube's optional second template in Brand settings → Platform Templates
 * (2026-10-08), one row under the main template's row for the same
 * orientation. With both set, a Default choice says which one the editor
 * opens first. Shown for YouTube only; every other row is unchanged.
 */
export default function SecondTemplateRow({ platform, orientation, main, second, editorTemplates, saving, onAssign, onSetDefault }) {
  const asOption = (row) =>
    row ? editorTemplates.find((t) => t.id === row.template_id) || { id: row.template_id, name: row.template_name } : null;
  const defaultSlot = second && second.is_default ? "second" : "main";

  return (
    <TableRow data-testid={`second-template-${platform}-${orientation}`}>
      <TableCell sx={{ color: "text.secondary", pl: 4 }}>↳ second (optional)</TableCell>
      <TableCell sx={{ textTransform: "capitalize", color: "text.secondary" }}>{orientation}</TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
          <Autocomplete
            size="small"
            options={editorTemplates}
            getOptionLabel={(o) => o.name || o.id}
            value={asOption(second)}
            onChange={(_, t) => onAssign(t)}
            isOptionEqualToValue={(o, v) => o.id === v?.id}
            sx={{ minWidth: 220 }}
            renderInput={(params) => <TextField {...params} placeholder="No second template" size="small" />}
          />
          {main && second && (
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="caption" fontWeight={700}>
                Default:
              </Typography>
              <RadioGroup
                row
                value={defaultSlot}
                onChange={(e) => onSetDefault(e.target.value === "second" ? second : main)}
                aria-label={`${platform} ${orientation} default template`}
              >
                <FormControlLabel value="main" control={<Radio size="small" />} label={<Typography variant="caption">Main</Typography>} />
                <FormControlLabel value="second" control={<Radio size="small" />} label={<Typography variant="caption">Second</Typography>} />
              </RadioGroup>
            </Box>
          )}
          {saving && <CircularProgress size={16} />}
        </Box>
      </TableCell>
    </TableRow>
  );
}
